import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useContext } from 'react'
import { createSupplierFeedback } from '../../../../action';
import { GlobalState } from '../../../../GlobalState'
import axios from '../../../../helpers/axios'
import { api } from '../../../../util/urlConfig';
import SupplierReply from '../SupplierReply';
import './comment.css'

function SupplierComment({ feedback }) {
    const state = useContext(GlobalState);
    const [callback, setCallback] = state.supplierFeedbackAPI.callback;

    const [replyData, setReplyData] = useState([]);
    const [show, setShow] = useState(false);
    const [values, setValues] = useState({});
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    const dateConverter = (date) => {
        let convertedDate = new Date(date).toISOString().slice(0, 10);
        return convertedDate
    }

    const getReply = async (id) => {
        const res = await axios.get(`/supplierfeedback/getbyparentid/${id}`);
        setReplyData(res.data.response)
    }

    const onChangeValue = (e) => {
        e.preventDefault();
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        getReply(feedback.id);
    }, [feedback]);

    const submitReply = (e) => {
        e.preventDefault();

        const feedbackInfo = {
            note: values.note,
            supplierId: feedback.supplier.id,
            updatedBy: signInUser.id,
            createdBy: signInUser.id,
            feedback_parent_id: feedback.id
        }

        createSupplierFeedback(feedbackInfo, res => {
            if (res.status === 200) {
                setCallback(!callback)
                setShow(false)
                values.note = "";
            }
        })
    }

    return (
        <div className='comment-container'>
            <div className="head-comment">
                <div className='title-area'>
                    <img src={feedback.supplier.upload_image ? api + "/" + feedback.supplier.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
                    <h3>{feedback.supplier.first_name + " " + feedback.supplier.last_name}</h3>
                </div>
                <p>{dateConverter(feedback.created_at)}</p>
            </div>
            <div className="comment">
                <p>
                    {feedback.note}
                </p>
            </div>
            {
                show ? <div></div>
                    : <div onClick={() => setShow(true)} className="reply-btn">
                        <button>Reply</button>
                    </div>
            }

            {
                show ?
                    <div>
                        <div className="input-box">
                            <textarea
                                name="note"
                                id="note"
                                cols="30" rows="5"
                                placeholder='Enter feedback here...'
                                value={values.note || ""}
                                onChange={onChangeValue}
                            />
                        </div>
                        <div className="form-button">
                            <button onClick={(e) => submitReply(e)} className="add_new">Reply</button>
                        </div>
                    </div>
                    : <div></div>
            }

            <div className='replay'>
                {
                    replyData.data ? replyData.data.map(reply => (
                        <div className='reply-content' key={reply.id}>
                            <SupplierReply reply={reply} />
                        </div>
                    ))
                        : <div></div>
                }
            </div>
        </div>
    )
}

export default SupplierComment